export const CSRF_COOKIE = 'mh_csrf';
export const CSRF_HEADER = 'x-csrf-token';

export function readCsrfCookie(): string | null {
  const match = document.cookie
    .split(';')
    .map((c) => c.trim())
    .find((c) => c.startsWith(`${CSRF_COOKIE}=`));
  if (!match) return null;
  return decodeURIComponent(match.slice(CSRF_COOKIE.length + 1));
}

const MUTATING = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

export function needsCsrf(method: string): boolean {
  return MUTATING.has(method.toUpperCase());
}
